import React from 'react';

function Marquee() {
  const items = [
    'Health Awareness',
    'Education Equity',
    'Cultural Heritage',
    'Eco Sustainability',
    'Community Empowerment',
    'Vocational Skills',
  ];
  return (
    <section>
      <div className="main-marq xlrg o-hidden">
        <div className="slide-har st1">
          <div className="box">
            {items.map((item, i) => (
              <div className="item" key={i}>
                <h4 className="d-flex align-items-center">
                  <span>{item}</span>
                  <span className="fz-50 ml-50 stroke icon">*</span>
                </h4>
              </div>
            ))}
          </div>
          <div className="box">
            {items.map((item, i) => (
              <div className="item" key={i}>
                <h4 className="d-flex align-items-center">
                  <span>{item}</span>
                  <span className="fz-50 ml-50 stroke icon">*</span>
                </h4>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Marquee;
